import { PUBLIC_SWR_KEYS } from "../Utilities/swrKeys";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useCachedSWR } from "../Utilities/useCachedSWR";
// Retrieves delivery questions data from the cache using SWR; this does not trigger a network request.
export const useDeliveryQuestionsQuery = () => {
    const { datadogLog } = useLogging();
    const { data, error: fetchError, isLoading, } = useCachedSWR(PUBLIC_SWR_KEYS.DELIVERY_QUESTIONS, {
        onError: (error) => {
            datadogLog("Failed to fetch account delivery questions.", LogLevel.ERROR, undefined, error);
        },
    });
    return { data, fetchError, isLoading };
};
